import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import Config from "./../config.json";

export const commentApi = createApi({
  reducerPath: "commentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/comments/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getAllComments: builder.query({
      query: () => ({
        url: "getAll",
        params: {},
        method: "GET",
      }),
    }),
    getReplies: builder.query({
      query: (id) => ({
        url: `getreplies/${id}`,
        params: {},
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Reply", id: "List" },
        ...(result ?? []).map((user) => ({ type: "Reply", id: user.id })),
      ],
    }),
    postComment: builder.mutation({
      query: (comment) => ({
        url: "postComment",
        body: comment,
        method: "POST",
      }),
    }),
    postReply: builder.mutation({
      query: (comment) => ({
        url: "postReply",
        body: comment,
        method: "POST",
      }),
    }),
    updateCommentImages: builder.mutation({
      query: (comment) => ({
        url: `UpdateCommentImages/${comment.id}`,
        body: comment,
        method: "PUT",
      }),
    }),
    deleteComment: builder.mutation({
      query: (id) => ({
        url: `DeleteCrop/${id}`,
        body: id,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useUpdateCommentImagesMutation,
  useGetAllCommentsQuery,
  useGetRepliesQuery,
  useDeleteCommentMutation,
  usePostCommentMutation,
  useUpdateCommentMutation,
  usePostReplyMutation,
} = commentApi;
